import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useRef } from "react";
import limpiarHtml from '../Compartido/limpiarHtml.js';


const PropiedadesBuscar = ({ lang, ruta, propiedades = [], adultos, ninos, bebes, llegada, salida, config, moneda, websgrupo, otraspropiedades = [], otrasEstanciaMinima = [], nodisponibles = [], nuevosadultos, distribucion = [] }) => {
    const { t } = useTranslation();

    // Es reserva pel carret (i es pot seguir afegint habitacions) amb multiunit
    // o quan la cerca és de més d'una habitació. Si no, "Reservar" va directe
    // a la reserva d'aquella propietat.
    const usaCarrito = websgrupo.activa_multiunit === 1 || distribucion.length > 1;

    // Cerca de diverses habitacions sense dates: no hi ha preus ni tarifes, per
    // tant no es pot afegir cap habitació al carret. Es demana triar les dates
    // (s'obre el calendari del cercador) en lloc d'anar a la fitxa.
    const sinFechasVarias = distribucion.length > 1 && !(llegada && salida);
    const abrirCalendario = (e) => {
        if (e) e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
            const campo = document.querySelector('input[name="daterange"]');
            if (campo) campo.click();
        }, 350);
    };
    var preidioma = "";
    if (lang != 'es') preidioma = lang + "/";

    const [showMore, setshowMore] = useState(-1);
    const [modalPolitica, setModalPolitica] = useState(null);
    const [detallesAbiertos, setDetallesAbiertos] = useState({});
    const toggleDetalles = (key) => setDetallesAbiertos((prev) => ({ ...prev, [key]: !prev[key] }));
    const [carritoAbierto, setCarritoAbierto] = useState(false);

    const refNoDisponibles = useRef(null);
    const [fechasAlt, setFechasAlt] = useState(null);
    useEffect(() => {
        const bloc = refNoDisponibles.current;
        if (!bloc || !llegada || !salida || !nodisponibles || nodisponibles.length === 0) return;

        const demana = () => {
            const token = document.getElementById("meta_token")?.getAttribute("content");
            fetch("/fechasalternativas", {
                method: "POST",
                headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-TOKEN": token },
                body: JSON.stringify({ ids: nodisponibles.map((p) => p.id), llegada, salida, adultos }),
            })
                .then((r) => (r.ok ? r.json() : {}))
                .then((dades) => setFechasAlt(dades && !Array.isArray(dades) ? dades : {}))
                .catch(() => setFechasAlt({}));
        };

        if (!("IntersectionObserver" in window)) {
            demana();
            return;
        }
        const obs = new IntersectionObserver((entrades) => {
            if (entrades.some((e) => e.isIntersecting)) {
                obs.disconnect();
                demana();
            }
        }, { rootMargin: "400px 0px" });
        obs.observe(bloc);
        return () => obs.disconnect();
    }, [llegada, salida, adultos, nodisponibles]);

    // Es guarda al sessionStorage 
    const clauCarrito = `bh-carrito-${llegada}-${salida}`;

    const [habitacionesSeleccionadas, setHabitacionesSeleccionadas] = useState(() => {
        try {
            const guardat = sessionStorage.getItem(clauCarrito);
            return guardat ? JSON.parse(guardat) : {};
        } catch (e) {
            return {};
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem(clauCarrito, JSON.stringify(habitacionesSeleccionadas));
        } catch (e) {
            // Safari privat, quota plena, etc. — el carret continua
            // funcionant en memòria, només no sobreviu a un refresc.
        }
    }, [habitacionesSeleccionadas, clauCarrito]);

    // Mare i filles d'un grup de propietats no es poden reservar juntes:
    // si es reserva la mare les filles queden ocupades (i al revés). Les
    // filles entre elles sí que es poden combinar. El backend també ho valida.
    const totesPropietats = [...(propiedades || []), ...(otraspropiedades || []), ...(otrasEstanciaMinima || [])];
    const bloquejadaPerGrup = (propiedad, seleccio = habitacionesSeleccionadas) => {
        if (!propiedad?.grupo_id || !propiedad.grupo_padre_id) {
            return false;
        }
        return Object.values(seleccio).some((s) => {
            if (s.idpropiedad === propiedad.id) {
                return false;
            }
            const grupoAltra = s.grupo_id ?? totesPropietats.find((p) => p.id === s.idpropiedad)?.grupo_id;
            return grupoAltra === propiedad.grupo_id
                && (propiedad.id === propiedad.grupo_padre_id || s.idpropiedad === propiedad.grupo_padre_id);
        });
    };

    const conflicteCarret = Object.values(habitacionesSeleccionadas).some((h) =>
        bloquejadaPerGrup(totesPropietats.find((p) => p.id === h.idpropiedad) || { id: h.idpropiedad, grupo_id: h.grupo_id, grupo_padre_id: h.grupo_padre_id })
    );

    const cambiarCantidadHabitacion = (propiedad, tarifa) => {
        const key = `${propiedad.id}-${tarifa.id}`;

        setHabitacionesSeleccionadas((prev) => {

            const cantidadTotalPropiedad = Object.values(prev)
                .filter(
                    (seleccion) =>
                        seleccion.idpropiedad === propiedad.id
                )
                .reduce(
                    (total, seleccion) =>
                        total + Number(seleccion.cantidad),
                    0
                );

            // Ya no quedan habitaciones
            if (cantidadTotalPropiedad >= propiedad.numpropiedades) {
                return prev;
            }

            // Mare i filla del mateix grup
            if (bloquejadaPerGrup(propiedad, prev)) {
                return prev;
            }

            const seleccionActual = prev[key];
            const cantidadActual =
                seleccionActual?.cantidad || 0;

            return {
                ...prev,
                [key]: {
                    idpropiedad: propiedad.id,
                    grupo_id: propiedad.grupo_id ?? null,
                    grupo_padre_id: propiedad.grupo_padre_id ?? null,

                    nombrepropiedad:
                        propiedad.nombre_traducido &&
                            propiedad.nombre_traducido[lang]
                            ? propiedad.nombre_traducido[lang]
                            : propiedad.nombre,

                    tarifa: tarifa.id,

                    nombretarifa:
                        tarifa.info_tarifa?.nombre_web_traducido?.[lang] ||
                        tarifa.info_tarifa?.nombre_web ||
                        "",

                    cantidad: Number(cantidadActual) + 1,

                    precio: tarifa.suma
                }
            };
        });
    };


    const eliminarHabitacion = (idpropiedad, tarifa) => {
        const key = `${idpropiedad}-${tarifa}`;

        setHabitacionesSeleccionadas((prev) => {

            const seleccion = prev[key];

            if (!seleccion) {
                return prev;
            }

            const nuevas = { ...prev };

            if (Number(seleccion.cantidad) <= 1) {
                delete nuevas[key];
            } else {
                nuevas[key] = {
                    ...seleccion,
                    cantidad: Number(seleccion.cantidad) - 1
                };
            }

            return nuevas;
        });
    };



    const afegitRef = useRef(false);
    useEffect(() => {
        if (afegitRef.current || !usaCarrito) return;
        afegitRef.current = true;

        const params = new URLSearchParams(window.location.search);
        const id = Number(params.get("afegir"));
        if (!id) return;

        // Treu ?afegir de la URL (després que Inertia hi escrigui la seva) i
        // recorda que ja s'ha fet: un F5 no el torna a afegir.
        params.delete("afegir");
        const query = params.toString();
        setTimeout(() => window.history.replaceState(window.history.state, "", window.location.pathname + (query ? "?" + query : "")), 0);
        const clauAfegit = "bh-afegit-" + id + "-" + llegada + "-" + salida;
        try {
            if (sessionStorage.getItem(clauAfegit)) return;
            sessionStorage.setItem(clauAfegit, "1");
        } catch (e) {
            // sense sessionStorage: com a molt es tornaria a afegir en un F5
        }

        const propiedad = (propiedades || []).find((p) => p.id === id);
        const tarifas = (propiedad?.tarifas || []).filter((t) => t.suma > 0);
        if (tarifas.length === 0) return;
        if (Object.values(habitacionesSeleccionadas).some((h) => h.idpropiedad === id)) return;

        cambiarCantidadHabitacion(propiedad, tarifas.reduce((a, b) => (b.suma < a.suma ? b : a)));
    }, []);

    // Mentre carrega la cerca amb les dates noves (navegació completa, el
    // servidor tarda) es mostra ja l'esquelet del llistat en lloc de deixar
    // la pàgina vella quieta.
    const [navegantA, setNavegantA] = useState(null);
    useEffect(() => {
        // Tornar enrere amb el bfcache: la pàgina vella no ha de quedar en "carregant"
        const alMostrar = (e) => { if (e.persisted) setNavegantA(null); };
        window.addEventListener("pageshow", alMostrar);
        return () => window.removeEventListener("pageshow", alMostrar);
    }, []);

    const anarAmbDates = (e, opcio, href) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        setNavegantA(opcio);
        const reduir = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: 0, behavior: reduir ? "auto" : "smooth" });
        // Dos frames: que l'esquelet es pinti abans que comenci la navegació
        requestAnimationFrame(() => requestAnimationFrame(() => window.location.assign(href)));
    };

    // Mateixa cerca amb unes altres dates (i la propietat a afegir al carret)
    const urlCercaAmbDates = (opcio, id) => {
        const dma = (s) => s.split("-").reverse().join("/");
        const url = new URL(window.location.href);
        ["fecha_entrada", "fecha_salida", "llegada", "salida"].forEach((k) => url.searchParams.delete(k));
        url.searchParams.set("daterange", dma(opcio.llegada) + " - " + dma(opcio.salida));
        url.searchParams.set("afegir", id);
        return url.pathname + url.search;
    };

    const prepararReserva = () => {
        const habitaciones = Object.values(habitacionesSeleccionadas);

        if (habitaciones.length === 0 || conflicteCarret) {
            return;
        }

        console.log("preparo reserva");

        // Obtener CSRF token de la cabecera de la página
        const csrfToken = document.getElementById('meta_token').getAttribute('content');

        if (!csrfToken) {
            console.error("No se ha encontrado el token CSRF");
            return;
        }

        const form = document.createElement("form");

        form.method = "POST";
        form.action = "/" + preidioma + t("reservahotel");

        const añadirCampo = (nombre, valor) => {
            const input = document.createElement("input");

            input.type = "hidden";
            input.name = nombre;
            input.value = valor ?? "";

            form.appendChild(input);
        };

        // CSRF
        añadirCampo("_token", csrfToken);

        // Habitaciones
        añadirCampo(
            "habitaciones",
            JSON.stringify(habitaciones)
        );

        // Huéspedes
        // Sense distribució, els adults enviats són els que caben al carret.
        añadirCampo("adultos", distribucion.length > 1 ? adultos : adultsPerLinia.reduce((a, b) => a + b, 0));
        añadirCampo("ninos", ninos);
        añadirCampo("bebes", bebes);
        añadirCampo("distribucion", distribucion.length < 2 ? "" : distribucion.map(h => h.adultos + "-" + h.ninos).join(";"));

        // Fechas
        añadirCampo("llegada", llegada);
        añadirCampo("salida", salida);

        // Añadimos el formulario al DOM
        document.body.appendChild(form);

        // Enviamos
        form.submit();
    };

    const habitacionesSeleccionadasArray = Object.values(
        habitacionesSeleccionadas
    );

    // Cada unitat seleccionada (una per "cantidad") ocupa, en ordre, la
    // següent habitació del cercador (Habitació 1, 2, 3...) i n'hereta els
    // adults/nens. Sense distribució (cerca d'una sola habitació) queda buit
    // i es mostra el total de sempre.
    const habitacionsPerLinia = (() => {
        let desplacament = 0;
        return habitacionesSeleccionadasArray.map((h) => {
            const unitats = Number(h.cantidad) || 0;
            const assignades = distribucion.length > 1
                ? distribucion.slice(desplacament, desplacament + unitats).map((d, i) => ({ ...d, numero: desplacament + i + 1 }))
                : [];
            desplacament += unitats;
            return assignades;
        });
    })();

    // Ressalta el botó "Ver mi reserva" del header un instant cada cop
    // que s'afegeix una habitació, perquè quedi clar que ha aparegut
    // allà dalt (no és evident amb un simple canvi de número al badge).
    const [pulsarTrigger, setPulsarTrigger] = useState(false);
    // null = encara no comparat cap cop — evita que un carret restaurat
    // del sessionStorage en carregar la pàgina (F5) faci pulsar el botó
    // com si s'acabés d'afegir just ara.
    const cantidadAnteriorRef = useRef(null);

    useEffect(() => {
        const cantidadActual = habitacionesSeleccionadasArray.reduce((total, h) => total + Number(h.cantidad), 0);
        if (cantidadAnteriorRef.current !== null && cantidadActual > cantidadAnteriorRef.current) {
            setPulsarTrigger(true);
        }
        cantidadAnteriorRef.current = cantidadActual;
    }, [habitacionesSeleccionadasArray]);

    // Efecte separat perquè NOMÉS es reinicia quan pulsarTrigger canvia
    // (no en cada re-render del carret) — si el timer visqués dins
    // l'effect de dalt, qualsevol re-render aliè durant el pols
    // cancel·laria el clearTimeout abans d'hora i el deixaria "encès"
    // per sempre.
    useEffect(() => {
        if (!pulsarTrigger) return;
        const temporizador = setTimeout(() => setPulsarTrigger(false), 1200);
        return () => clearTimeout(temporizador);
    }, [pulsarTrigger]);

    const totalSeleccionado = Object.values(
        habitacionesSeleccionadas
    ).reduce(
        (total, habitacion) =>
            total + (
                habitacion.precio *
                habitacion.cantidad
            ),
        0
    );

    // Per pintar la targeta de cada habitació seleccionada (foto, enllaç
    // "Modificar", política de cancel·lació): les dades ja arriben dins
    // propiedades/otraspropiedades, només cal retrobar-les per id.
    const todasLasPropiedades = [...(propiedades || []), ...(otraspropiedades || [])];

    // Sense distribució per habitacions, els adults de la cerca es reparteixen
    // en ordre per les línies del carret sense passar de la capacitat de cada
    // allotjament (cercar 10 i triar un de 8 places → 8 adults).
    const adultsPerLinia = (() => {
        let restants = Number(adultos) || 0;
        return habitacionesSeleccionadasArray.map((h) => {
            const prop = todasLasPropiedades.find((p) => p.id === h.idpropiedad);
            const capacitat = (Number(prop?.capacidad_maxima) || 0) * (Number(h.cantidad) || 0);
            const assignats = capacitat > 0 ? Math.min(restants, capacitat) : restants;
            restants -= assignats;
            return assignats;
        });
    })();

    const calcularNoches = (desde, hasta) => {
        if (!desde || !hasta) return null;
        const dias = Math.round((new Date(hasta) - new Date(desde)) / 86400000);
        return dias > 0 ? dias : null;
    };

    // llegada/salida arriben com "YYYY-MM-DD" — es mostren com DD/MM/YYYY
    // (amb l'any, imprescindible si la reserva no és del mateix any).
    const formatoFechaLlarga = (data) => {
        if (!data) return "";
        const parts = data.split("-");
        return parts.length === 3 ? parts[2] + "/" + parts[1] + "/" + parts[0] : data;
    };

    const nochesSeleccion = calcularNoches(llegada, salida);

    // Alternatives de menor capacitat (sense resultats o sota els resultats)
    // Les alternatives (capacitat menor a la buscada) també passen pel carret
    // multiunit, així es poden combinar diverses habitacions (p. ex. dues de
    // 6 per a 12 persones) i barrejar-les amb els resultats. Sense multiunit
    // van directes a la reserva amb els hostes ajustats (nuevosadultos).
    const enCarritoAlternativas = usaCarrito;
    const bloqueOtras = otraspropiedades && otraspropiedades.length > 0 && (
                                            <>
                                                <div className="bh-otras-titulo" style={{ width: "100%" }}>
                                                    <h3>{t("Opciones perfectas para repartir el grupo")}</h3>
                                                    <p>{t("Propiedades libres para")} {nuevosadultos} {t("Adultos")}</p>
                                                </div>
                                                {
                                                    otraspropiedades.map((propiedad, index) => (

                                                        <div className="apartment-card" key={"d" + index}>

                                                            {/* Fila superior: foto + contingut */}
                                                            <div className="apartment-card-top">
                                                                <a href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica}>
                                                                    {propiedad.foto_principal && propiedad.foto_principal.length != 0 ? (
                                                                        <LazyLoadImage
                                                                            className="dynamic-apartment-image"
                                                                            effect='blur'
                                                                            threshold={10}
                                                                            src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/thumb/" + propiedad.foto_principal[0].nombre}
                                                                            alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""}
                                                                            title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""}
                                                                        />
                                                                    ) : (
                                                                        <LazyLoadImage
                                                                            className="dynamic-apartment-image"
                                                                            effect='blur'
                                                                            threshold={10}
                                                                            src="/images/web/bedloop-nofoto.png"
                                                                            alt=""
                                                                            title=""
                                                                        />
                                                                    )}
                                                                    {!!(nuevosadultos && llegada && salida) && (
                                                                        <span className="bottom-0 px-3 py-2 mb-3 bg-white border badge rounded-pill border-secondary text-dark fw-normal text-nowrap d-md-none position-absolute end-0 ms-2">
                                                                            <span className="text-muted small me-1">{t("Desde")}</span>
                                                                            {String(Math.floor(propiedad.precio / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                                                            <small>,{String((propiedad.precio / 100).toFixed(2)).split(".")[1]}</small>
                                                                            {" "}{moneda}
                                                                        </span>
                                                                    )}
                                                                </a>

                                                                <div className="apartment-card-content">
                                                                    <div className="apartment-text">
                                                                        <h3 className="gap-2 d-flex align-items-baseline justify-content-between">
                                                                            <a href={nuevosadultos && llegada && salida
                                                                                ? "/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica + "?adultos=" + nuevosadultos + "&ninos=" + ninos + "&bebes=" + bebes + "&llegada=" + llegada + "&salida=" + salida
                                                                                : "/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica
                                                                            }>
                                                                                {
                                                                                    propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ?
                                                                                        propiedad.nombre_traducido[lang]
                                                                                        :
                                                                                        propiedad.nombre
                                                                                }
                                                                            </a>
                                                                            {!!(nuevosadultos && llegada && salida) && (
                                                                                <span className="px-3 py-2 bg-white border badge rounded-pill border-secondary text-dark fw-normal text-nowrap d-none d-md-inline-block">
                                                                                    <span className="text-muted small me-1">{t("Desde")}</span>
                                                                                    {String(Math.floor(propiedad.precio / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                                                                    <small>,{String((propiedad.precio / 100).toFixed(2)).split(".")[1]}</small>
                                                                                    {" "}{moneda}
                                                                                </span>
                                                                            )}
                                                                        </h3>

                                                                        <div dangerouslySetInnerHTML={{ __html: propiedad.descripcion_corta?.[lang] ?? "" }}></div>

                                                                        {websgrupo.activa_multiunit === 1 && !!(llegada && salida) && propiedad.numpropiedades >= 1 && propiedad.numpropiedades <= 5 && (
                                                                            <span className={propiedad.numpropiedades == 1 ? "small text-danger fw-bolder" : propiedad.numpropiedades == 2 ? "small text-warning fw-bolder" : "small text-success fw-bolder"}>
                                                                                {propiedad.numpropiedades == 1
                                                                                    ? <i className="fa-solid fa-circle fa-beat me-1 text-danger"></i>
                                                                                    : propiedad.numpropiedades == 2
                                                                                        ? <i className="fa-solid fa-circle fa-beat me-1 text-warning"></i>
                                                                                        : null
                                                                                }
                                                                                {propiedad.numpropiedades == 1 ? t("Solo queda") + " 1 " + t("disponible") : t("Solo quedan") + " " + propiedad.numpropiedades + " " + t("disponibles")}
                                                                            </span>
                                                                        )}

                                                                        <div className="apartment-tags">
                                                                            <span><i className="fa-duotone fa-users"></i> {propiedad.capacidad_maxima}</span>
                                                                            <span><i className="fa-duotone fa-bed"></i> {propiedad.num_habitaciones}</span>
                                                                            <span><i className="fa-duotone fa-bath"></i> {propiedad.num_banyos}</span>
                                                                            <span>{propiedad.ciudad}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="apartment-view">
                                                                        {(!nuevosadultos || !llegada || !salida) && propiedad.by_request == 0 ? (
                                                                            <a
                                                                                href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica}
                                                                                className="btn btn-primary"
                                                                                style={{ background: config.color_corporativo_web, border: "1px solid" + config.color_corporativo_web, float: "right" }}
                                                                            >
                                                                                <i className="fa-duotone fa-calendar-check"></i> {t("Reservar")}
                                                                            </a>
                                                                        ) : (!nuevosadultos || !llegada || !salida) && propiedad.by_request == 1 ? (
                                                                            <a href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica} className="btn btn-primary" style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web, float: "right" }}>
                                                                                <i className="fa-duotone fa-calendar-check"></i> {t("Petición")}
                                                                            </a>
                                                                        ) :
                                                                            ""
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Fila inferior: tarifes a tota l'amplada */}
                                                            {!!(nuevosadultos && llegada && salida) && propiedad.tarifas.length > 0 && (
                                                                <div className="pt-2 d-flex flex-column w-100">
                                                                    {bloquejadaPerGrup(propiedad) && (
                                                                        <div className="mb-2 small text-danger">
                                                                            <i className="fa-solid fa-circle-info me-1"></i>
                                                                            {t("No combinable con la propiedad del mismo grupo ya seleccionada")}
                                                                        </div>
                                                                    )}
                                                                    {propiedad.tarifas.map((unatarifa) => {
                                                                        const key = `${propiedad.id}-${unatarifa.id}`;

                                                                        // Cantidad seleccionada de esta tarifa
                                                                        const cantidadSeleccionada =
                                                                            habitacionesSeleccionadas[key]?.cantidad || 0;

                                                                        // Total de habitaciones seleccionadas de esta propiedad,
                                                                        // independientemente de la tarifa
                                                                        const cantidadTotalPropiedad = Object.values(
                                                                            habitacionesSeleccionadas
                                                                        )
                                                                            .filter(
                                                                                (seleccion) =>
                                                                                    seleccion.idpropiedad === propiedad.id
                                                                            )
                                                                            .reduce(
                                                                                (total, seleccion) =>
                                                                                    total + Number(seleccion.cantidad),
                                                                                0
                                                                            );

                                                                        // ¿Queda alguna habitación disponible?
                                                                        const puedeReservar =
                                                                            cantidadTotalPropiedad < propiedad.numpropiedades && !bloquejadaPerGrup(propiedad);
                                                                        return (
                                                                            <div key={unatarifa.id} className="py-2 mb-2 border-top">

                                                                                {/* Política de cancel·lació */}
                                                                                <div className="gap-2 mb-2 d-flex align-items-center">
                                                                                    <span className="small text-muted">{unatarifa.info_tarifa?.politica?.nombre?.[lang]}</span>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="px-1 py-0 btn btn-success lh-2" style={{ fontSize: "0.65em" }}
                                                                                        onClick={() => setModalPolitica({ nombre: unatarifa.info_tarifa?.politica?.nombre?.[lang], descripcion: unatarifa.info_tarifa?.politica?.descripcion?.[lang] })}
                                                                                    >
                                                                                        {t("+ info")}
                                                                                    </button>
                                                                                </div>

                                                                                {/* Nom tarifa + preu + botó */}
                                                                                <div className="flex-wrap gap-3 d-flex align-items-center justify-content-between">
                                                                                    <div className="gap-2 d-flex align-items-center justify-content-between flex-md-grow-1 tarifa-info">
                                                                                        <span className="fw-bolder">
                                                                                            <i className="fa-solid fa-circle-check text-success me-2"></i>
                                                                                            {
                                                                                                unatarifa.info_tarifa ?
                                                                                                    unatarifa.info_tarifa.nombre_web_traducido && unatarifa.info_tarifa.nombre_web_traducido[lang] ?
                                                                                                        unatarifa.info_tarifa.nombre_web_traducido[lang]
                                                                                                        :
                                                                                                        unatarifa.info_tarifa.nombre_web
                                                                                                    :
                                                                                                    unatarifa.info_tarifa.nombre_web
                                                                                            }
                                                                                        </span>
                                                                                        <span className="flex-shrink-0 fw-bolder text-nowrap fs-5">
                                                                                            {String(
                                                                                                Math.floor(unatarifa.suma / 100)
                                                                                            ).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}

                                                                                            <small style={{ fontSize: "0.6em" }}>
                                                                                                ,{String(
                                                                                                    (unatarifa.suma / 100).toFixed(2)
                                                                                                ).split(".")[1]}
                                                                                            </small>

                                                                                            {" "}{moneda}
                                                                                        </span>
                                                                                        {cantidadSeleccionada > 0 && (
                                                                                            <span className="small text-success">
                                                                                                {cantidadSeleccionada} × {(
                                                                                                    unatarifa.suma / 100
                                                                                                ).toFixed(2)} {moneda}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                    {(() => {
                                                                                        const key = `${propiedad.id}-${unatarifa.id}`;

                                                                                        const cantidad = habitacionesSeleccionadas[key]?.cantidad || 0;

                                                                                        return (
                                                                                            <div className="gap-3 d-flex align-items-center">

                                                                                                {enCarritoAlternativas ? (

                                                                                                    <>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="px-4 text-white btn btn-sm text-nowrap rounded-pill tarifa-reservar"
                                                                                                            disabled={!puedeReservar}
                                                                                                            onClick={() =>
                                                                                                                cambiarCantidadHabitacion(
                                                                                                                    propiedad,
                                                                                                                    unatarifa
                                                                                                                )
                                                                                                            }
                                                                                                            style={{
                                                                                                                background: puedeReservar
                                                                                                                    ? config.color_corporativo_web
                                                                                                                    : "#adb5bd",
                                                                                                                border: "1px solid " + (
                                                                                                                    puedeReservar
                                                                                                                        ? config.color_corporativo_web
                                                                                                                        : "#adb5bd"
                                                                                                                )
                                                                                                            }}
                                                                                                        >
                                                                                                            {t("Reservar")}
                                                                                                            <i className="fa-solid fa-arrow-right ms-1"></i>
                                                                                                        </button>

                                                                                                    </>

                                                                                                ) : (

                                                                                                    <a
                                                                                                        href={
                                                                                                            propiedad.by_request == 0
                                                                                                                ? "/" + preidioma + t("reserva") +
                                                                                                                "?idpropiedad=" + propiedad.id +
                                                                                                                "&adultos=" + nuevosadultos +
                                                                                                                "&ninos=" + ninos +
                                                                                                                "&bebes=" + bebes +
                                                                                                                "&daterange=" + llegada + " - " + salida +
                                                                                                                "&solorequest=0" +
                                                                                                                "&tarifa=" + unatarifa.id
                                                                                                                : "/" + preidioma + t("peticion") +
                                                                                                                "?idpropiedad=" + propiedad.id +
                                                                                                                "&adultos=" + nuevosadultos +
                                                                                                                "&ninos=" + ninos +
                                                                                                                "&bebes=" + bebes +
                                                                                                                "&entrada=" + llegada.replaceAll("-", "/") +
                                                                                                                "&salida=" + salida.replaceAll("-", "/") +
                                                                                                                "&solorequest=1" +
                                                                                                                "&tarifa=" + unatarifa.id
                                                                                                        }
                                                                                                        className="px-4 text-white btn btn-sm text-nowrap rounded-pill tarifa-reservar"
                                                                                                        style={{
                                                                                                            background: config.color_corporativo_web,
                                                                                                            border: "1px solid " + config.color_corporativo_web
                                                                                                        }}
                                                                                                    >
                                                                                                        {propiedad.by_request == 0
                                                                                                            ? t("Reservar")
                                                                                                            : t("Petición")
                                                                                                        }

                                                                                                        <i className="fa-solid fa-arrow-right ms-1"></i>
                                                                                                    </a>
                                                                                                )}

                                                                                            </div>
                                                                                        );
                                                                                    })()}
                                                                                </div>

                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}

                                                        </div>
                                                    ))
                                                }
                                            </>
                                        );

    // Data de sortida corregida perquè la propietat compleixi el seu propi
    // mínim de nits, a partir de la mateixa data d'entrada buscada.
    const calcularSalidaMinima = (desde, noches) => {
        if (!desde || !noches) return null;
        const d = new Date(desde);
        d.setDate(d.getDate() + Number(noches));
        return d.toISOString().split("T")[0];
    };

    // Propietats disponibles a les dates i capacitat buscades, però que
    // exigeixen una estada mínima superior a la sol·licitada.
    const bloqueEstanciaMinima = otrasEstanciaMinima && otrasEstanciaMinima.length > 0 && (
        <>
            <div className="bh-otras-titulo" style={{ width: "100%" }}>
                <h3>{t("¿Te quedas unos días más? Estos alojamientos te esperan")}</h3>
                <p>{t("Libres en tus fechas si amplías la estancia al mínimo de noches indicado")}</p>
            </div>
            {otrasEstanciaMinima.map((propiedad, index) => {
                const urlFicha = "/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica;
                const salidaMinima = calcularSalidaMinima(llegada, propiedad.dias_minimos_requeridos);
                const urlDisponibilidad = urlFicha + "?adultos=" + adultos + "&ninos=" + ninos + "&bebes=" + bebes
                    + (llegada && salidaMinima ? "&llegada=" + llegada + "&salida=" + salidaMinima : "");
                return (
                    <div className="apartment-card" key={"em" + index}>
                        <div className="apartment-card-top">
                            <a href={urlFicha}>
                                <LazyLoadImage
                                    className="dynamic-apartment-image"
                                    effect='blur'
                                    threshold={10}
                                    src={propiedad.foto_principal && propiedad.foto_principal.length != 0
                                        ? ruta + "/propiedades/" + propiedad.id + "/fotos/web/thumb/" + propiedad.foto_principal[0].nombre
                                        : "/images/web/bedloop-nofoto.png"}
                                    alt={propiedad.foto_principal?.[0]?.texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""}
                                />
                            </a>
                            <div className="apartment-card-content">
                                <div className="apartment-text">
                                    <h3>
                                        <a href={urlFicha}>
                                            {propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ? propiedad.nombre_traducido[lang] : propiedad.nombre}
                                        </a>
                                    </h3>
                                    <div className="apartment-tags">
                                        <span><i className="fa-duotone fa-users"></i> {propiedad.capacidad_maxima}</span>
                                        <span><i className="fa-duotone fa-bed"></i> {propiedad.num_habitaciones}</span>
                                        <span><i className="fa-duotone fa-bath"></i> {propiedad.num_banyos}</span>
                                        <span>{propiedad.ciudad}</span>
                                    </div>
                                </div>
                                <div className="apartment-view bh-no-disponible__acciones">
                                    <span className="px-3 py-2 bg-white border badge rounded-pill border-secondary text-dark fw-normal text-nowrap">
                                        {t("Estancia mínima")}: {propiedad.dias_minimos_requeridos} {t("Noches")}
                                    </span>
                                    <a href={urlDisponibilidad} className="px-4 text-white btn btn-sm text-nowrap rounded-pill text-decoration-none" style={{ background: config.color_corporativo_web, border: "1px solid " + config.color_corporativo_web }}>
                                        {t("Ver disponibilidad")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );

    const formatRang = (inici, fi) => {
        const d = (s) => { const [y, m, dd] = s.split("-").map(Number); return new Date(y, m - 1, dd); };
        try {
            const f = new Intl.DateTimeFormat(lang, { day: "numeric", month: "short" });
            return f.formatRange ? f.formatRange(d(inici), d(fi)) : f.format(d(inici)) + " – " + f.format(d(fi));
        } catch (e) {
            return inici + " – " + fi;
        }
    };

    // Propietats que encaixen amb la cerca però no estan disponibles a les
    // dates triades: van al final de tot, sota les alternatives.
    const bloqueNoDisponibles = nodisponibles && nodisponibles.length > 0 && (
        <>
            <div className="bh-otras-titulo" style={{ width: "100%" }} ref={refNoDisponibles}>
                <h3>{t("No disponibles en las fechas seleccionadas")}</h3>
                <p>{t("Prueba con otras fechas para ver su disponibilidad")}</p>
            </div>
            {nodisponibles.map((propiedad, index) => {
                const urlFicha = "/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica;
                return (
                    <div className="apartment-card bh-no-disponible" key={"nd" + index}>
                        <div className="apartment-card-top">
                            <a href={urlFicha}>
                                <LazyLoadImage
                                    className="dynamic-apartment-image"
                                    effect='blur'
                                    threshold={10}
                                    src={propiedad.foto_principal && propiedad.foto_principal.length != 0
                                        ? ruta + "/propiedades/" + propiedad.id + "/fotos/web/thumb/" + propiedad.foto_principal[0].nombre
                                        : "/images/web/bedloop-nofoto.png"}
                                    alt={propiedad.foto_principal?.[0]?.texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""}
                                />
                            </a>
                            <div className="apartment-card-content">
                                <div className="apartment-text">
                                    <h3>
                                        <a href={urlFicha}>
                                            {propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ? propiedad.nombre_traducido[lang] : propiedad.nombre}
                                        </a>
                                    </h3>
                                    <div className="apartment-tags">
                                        <span><i className="fa-duotone fa-users"></i> {propiedad.capacidad_maxima}</span>
                                        <span><i className="fa-duotone fa-bed"></i> {propiedad.num_habitaciones}</span>
                                        <span><i className="fa-duotone fa-bath"></i> {propiedad.num_banyos}</span>
                                        <span>{propiedad.ciudad}</span>
                                    </div>
                                    {fechasAlt === null ? (
                                        <div className="bh-fechas-alt bh-fechas-alt--carregant" aria-hidden="true">
                                            <span className="bh-fechas-alt__xip"></span>
                                            <span className="bh-fechas-alt__xip"></span>
                                        </div>
                                    ) : fechasAlt[propiedad.id] && fechasAlt[propiedad.id].length > 0 && (
                                        <div className="bh-fechas-alt">
                                            <span className="bh-fechas-alt__titol">{t("Fechas libres cercanas")}</span>
                                            <div className="bh-fechas-alt__llista">
                                                {fechasAlt[propiedad.id].map((opcio) => (
                                                    <a
                                                        key={opcio.llegada}
                                                        className="bh-fechas-alt__xip"
                                                        href={usaCarrito
                                                            ? urlCercaAmbDates(opcio, propiedad.id)
                                                            : urlFicha + "?adultos=" + adultos + "&ninos=" + ninos + "&bebes=" + bebes + "&llegada=" + opcio.llegada + "&salida=" + opcio.salida}
                                                        onClick={usaCarrito ? (e) => anarAmbDates(e, opcio, e.currentTarget.getAttribute("href")) : undefined}
                                                    >
                                                        <span>{formatRang(opcio.llegada, opcio.salida)}</span>
                                                        <strong>{String(Math.round(opcio.precio / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')} {moneda}</strong>
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="apartment-view bh-no-disponible__acciones">
                                    <span className="px-3 py-2 bg-white border badge rounded-pill border-secondary text-dark fw-normal text-nowrap">{t("No disponible")}</span>
                                    <button
                                        type="button"
                                        className="px-4 text-white btn btn-sm text-nowrap rounded-pill"
                                        onClick={abrirCalendario}
                                        style={{ background: config.color_corporativo_web, border: "1px solid " + config.color_corporativo_web }}
                                    >
                                        <i className="fa-regular fa-calendar"></i> {t("Cambiar fechas")}
                                    </button>
                                    <a href={urlFicha + "?adultos=" + adultos + "&ninos=" + ninos + "&bebes=" + bebes}>{t("Ver disponibilidad")}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );

    return (
        <>
            {modalPolitica && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} onClick={() => setModalPolitica(null)}>
                    <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="pb-0 border-0 modal-header">
                                <h6 className="modal-title fw-bolder">{modalPolitica.nombre}</h6>
                                <button type="button" className="btn-close" onClick={() => setModalPolitica(null)}></button>
                            </div>
                            <div className="pt-2 modal-body">
                                <p className="mb-0 small text-muted" dangerouslySetInnerHTML={{ __html: limpiarHtml(modalPolitica.descripcion) }}></p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="pt-5 resultats-hotel">
                {/*main content container */}
                <div className="main-content-container">
                    {/*apartments container*/}
                    <div className="apartments-container">

                        {/*dynamic apartment cards */}
                        <div className={"dynamic-apartments" + (navegantA ? " bh-navegant" : "")}>
                            {navegantA && (
                                <div className="bh-esquelet" role="status" aria-live="polite">
                                    <p className="bh-esquelet__text">
                                        <span className="bh-esquelet__spinner" aria-hidden="true"></span>
                                        {t("Buscando disponibilidad")} · {formatRang(navegantA.llegada, navegantA.salida)}
                                    </p>
                                    {[0, 1, 2].map((i) => (
                                        <div className="apartment-card bh-esquelet__card" key={i} aria-hidden="true">
                                            <div className="bh-esquelet__foto bh-brill"></div>
                                            <div className="bh-esquelet__cos">
                                                <div className="bh-brill bh-esquelet__titol"></div>
                                                <div className="bh-brill bh-esquelet__linia"></div>
                                                <div className="bh-brill bh-esquelet__linia bh-esquelet__linia--curta"></div>
                                                <div className="bh-esquelet__tags">
                                                    <span className="bh-brill"></span><span className="bh-brill"></span><span className="bh-brill"></span>
                                                </div>
                                                <div className="bh-esquelet__peu">
                                                    <span className="bh-brill bh-esquelet__preu"></span>
                                                    <span className="bh-brill bh-esquelet__boto"></span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {sinFechasVarias && (
                                <div className="bh-aviso-fechas" role="status">
                                    <i className="fa-regular fa-calendar"></i>
                                    <span>{t("Elige las fechas para ver la disponibilidad y añadir varias habitaciones")}</span>
                                    <button type="button" onClick={abrirCalendario} style={{ background: config.color_corporativo_web, borderColor: config.color_corporativo_web }}>{t("Elegir fechas")}</button>
                                </div>
                            )}
                            {propiedades.length > 0 ? (
                                propiedades.map((propiedad, index) => (
                                    <div className="apartment-card" key={"propiedad-" + propiedad.id}>

                                        {/* Fila superior: foto + contingut */}
                                        <div className="apartment-card-top">
                                            <a href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica}>
                                                {propiedad.foto_principal && propiedad.foto_principal.length != 0 ? (
                                                    <LazyLoadImage
                                                        className="dynamic-apartment-image"
                                                        effect='blur'
                                                        threshold={10}
                                                        src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/thumb/" + propiedad.foto_principal[0].nombre}
                                                        alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""}
                                                        title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""}
                                                    />
                                                ) : (
                                                    <LazyLoadImage
                                                        className="dynamic-apartment-image"
                                                        effect='blur'
                                                        threshold={10}
                                                        src="/images/web/bedloop-nofoto.png"
                                                        alt=""
                                                        title=""
                                                    />
                                                )}
                                                {!!(adultos && llegada && salida) && (
                                                    <span className="bottom-0 px-3 py-2 mb-3 bg-white border badge rounded-pill border-secondary text-dark fw-normal text-nowrap d-md-none position-absolute end-0 ms-2">
                                                        <span className="text-muted small me-1">{t("Desde")}</span>
                                                        {String(Math.floor(propiedad.precio / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                                        <small>,{String((propiedad.precio / 100).toFixed(2)).split(".")[1]}</small>
                                                        {" "}{moneda}
                                                    </span>
                                                )}
                                            </a>

                                            <div className="apartment-card-content">
                                                <div className="apartment-text">
                                                    <h3 className="gap-2 d-flex align-items-baseline justify-content-between">
                                                        <a href={adultos && llegada && salida
                                                            ? "/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica + "?adultos=" + adultos + "&ninos=" + ninos + "&bebes=" + bebes + "&llegada=" + llegada + "&salida=" + salida
                                                            : "/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica
                                                        }>
                                                            {
                                                                propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ?
                                                                    propiedad.nombre_traducido[lang]
                                                                    :
                                                                    propiedad.nombre
                                                            }
                                                        </a>
                                                        {!!(adultos && llegada && salida) && (
                                                            <span className="px-3 py-2 bg-white border badge rounded-pill border-secondary text-dark fw-normal text-nowrap d-none d-md-inline-block">
                                                                <span className="text-muted small me-1">{t("Desde")}</span>
                                                                {String(Math.floor(propiedad.precio / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                                                <small>,{String((propiedad.precio / 100).toFixed(2)).split(".")[1]}</small>
                                                                {" "}{moneda}
                                                            </span>
                                                        )}
                                                    </h3>

                                                    <div dangerouslySetInnerHTML={{ __html: propiedad.descripcion_corta?.[lang] ?? "" }}></div>

                                                    {websgrupo.activa_multiunit === 1 && !!(llegada && salida) && propiedad.numpropiedades >= 1 && propiedad.numpropiedades <= 5 && (
                                                        <span className={propiedad.numpropiedades == 1 ? "small text-danger fw-bolder" : propiedad.numpropiedades == 2 ? "small text-warning fw-bolder" : "small text-success fw-bolder"}>
                                                            {propiedad.numpropiedades == 1
                                                                ? <i className="fa-solid fa-circle fa-beat me-1 text-danger"></i>
                                                                : propiedad.numpropiedades == 2
                                                                    ? <i className="fa-solid fa-circle fa-beat me-1 text-warning"></i>
                                                                    : null
                                                            }
                                                            {propiedad.numpropiedades == 1 ? t("Solo queda") + " 1 " + t("disponible") : t("Solo quedan") + " " + propiedad.numpropiedades + " " + t("disponibles")}
                                                        </span>
                                                    )}

                                                    <div className="apartment-tags">
                                                        <span><i className="fa-duotone fa-users"></i> {propiedad.capacidad_maxima}</span>
                                                        <span><i className="fa-duotone fa-bed"></i> {propiedad.num_habitaciones}</span>
                                                        <span><i className="fa-duotone fa-bath"></i> {propiedad.num_banyos}</span>
                                                        <span>{propiedad.ciudad}</span>
                                                    </div>
                                                </div>

                                                <div className="apartment-view">
                                                    {(!adultos || !llegada || !salida) && propiedad.by_request == 0 ? (
                                                        <a onClick={sinFechasVarias ? abrirCalendario : undefined}
                                                            href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica}
                                                            className="btn btn-primary"
                                                            style={{ background: config.color_corporativo_web, border: "1px solid" + config.color_corporativo_web, float: "right" }}
                                                        >
                                                            <i className="fa-duotone fa-calendar-check"></i> {t("Reservar")}
                                                        </a>
                                                    ) : (!adultos || !llegada || !salida) && propiedad.by_request == 1 ? (
                                                        <a onClick={sinFechasVarias ? abrirCalendario : undefined} href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica} className="btn btn-primary" style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web, float: "right" }}>
                                                            <i className="fa-duotone fa-calendar-check"></i> {t("Petición")}
                                                        </a>
                                                    ) :
                                                        ""
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {/* Fila inferior: tarifes a tota l'amplada */}
                                        {!!(adultos && llegada && salida) && propiedad.tarifas.length > 0 && (
                                            <div className="pt-2 d-flex flex-column w-100">
                                                {bloquejadaPerGrup(propiedad) && (
                                                    <div className="mb-2 small text-danger">
                                                        <i className="fa-solid fa-circle-info me-1"></i>
                                                        {t("No combinable con la propiedad del mismo grupo ya seleccionada")}
                                                    </div>
                                                )}
                                                {propiedad.tarifas.map((unatarifa) => {

                                                    const key = `${propiedad.id}-${unatarifa.id}`;

                                                    // Cantidad seleccionada de esta tarifa
                                                    const cantidadSeleccionada =
                                                        habitacionesSeleccionadas[key]?.cantidad || 0;

                                                    // Total de habitaciones seleccionadas de esta propiedad,
                                                    // independientemente de la tarifa
                                                    const cantidadTotalPropiedad = Object.values(
                                                        habitacionesSeleccionadas
                                                    )
                                                        .filter(
                                                            (seleccion) =>
                                                                seleccion.idpropiedad === propiedad.id
                                                        )
                                                        .reduce(
                                                            (total, seleccion) =>
                                                                total + Number(seleccion.cantidad),
                                                            0
                                                        );

                                                    // ¿Queda alguna habitación disponible?
                                                    const puedeReservar =
                                                        cantidadTotalPropiedad < propiedad.numpropiedades && !bloquejadaPerGrup(propiedad);

                                                    return (
                                                        <div key={unatarifa.id} className="py-2 mb-2 border-top">

                                                            {/* Política de cancel·lació */}
                                                            <div className="gap-2 mb-2 d-flex align-items-center">
                                                                <span className="small text-muted">{unatarifa.info_tarifa?.politica?.nombre?.[lang]}</span>
                                                                <button
                                                                    type="button"
                                                                    className="px-1 py-0 btn btn-success lh-2" style={{ fontSize: "0.65em" }}
                                                                    onClick={() => setModalPolitica({ nombre: unatarifa.info_tarifa?.politica?.nombre?.[lang], descripcion: unatarifa.info_tarifa?.politica?.descripcion?.[lang] })}
                                                                >
                                                                    {t("+ info")}
                                                                </button>
                                                            </div>

                                                            {/* Nom tarifa + preu + botó */}
                                                            <div className="flex-wrap gap-3 d-flex align-items-center justify-content-between">
                                                                <div className="gap-2 d-flex align-items-center justify-content-between flex-md-grow-1 tarifa-info">
                                                                    <span className="fw-bolder">
                                                                        <i className="fa-solid fa-circle-check text-success me-2"></i>
                                                                        {
                                                                            unatarifa.info_tarifa ?
                                                                                unatarifa.info_tarifa.nombre_web_traducido && unatarifa.info_tarifa.nombre_web_traducido[lang] ?
                                                                                    unatarifa.info_tarifa.nombre_web_traducido[lang]
                                                                                    :
                                                                                    unatarifa.info_tarifa.nombre_web
                                                                                :
                                                                                unatarifa.info_tarifa.nombre_web
                                                                        }
                                                                    </span>
                                                                    <span className="flex-shrink-0 fw-bolder text-nowrap fs-5">
                                                                        {String(Math.floor(unatarifa.suma / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}<small style={{ fontSize: "0.6em" }}>,{String((unatarifa.suma / 100).toFixed(2)).split(".")[1]}</small> {moneda}
                                                                    </span>
                                                                </div>

                                                                <div className="gap-3 d-flex align-items-center">

                                                                    {usaCarrito ? (

                                                                        <>
                                                                            <button
                                                                                type="button"
                                                                                className="px-4 text-white btn btn-sm text-nowrap rounded-pill tarifa-reservar"
                                                                                disabled={!puedeReservar}
                                                                                onClick={() =>
                                                                                    cambiarCantidadHabitacion(
                                                                                        propiedad,
                                                                                        unatarifa
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    background: puedeReservar
                                                                                        ? config.color_corporativo_web
                                                                                        : "#adb5bd",
                                                                                    border: "1px solid " + (
                                                                                        puedeReservar
                                                                                            ? config.color_corporativo_web
                                                                                            : "#adb5bd"
                                                                                    )
                                                                                }}
                                                                            >
                                                                                {t("Reservar")}
                                                                                <i className="fa-solid fa-arrow-right ms-1"></i>
                                                                            </button>

                                                                        </>

                                                                    ) : (

                                                                        <a
                                                                            href={
                                                                                propiedad.by_request == 0
                                                                                    ? "/" + preidioma + t("reserva") +
                                                                                    "?idpropiedad=" + propiedad.id +
                                                                                    "&adultos=" + adultos +
                                                                                    "&ninos=" + ninos +
                                                                                    "&bebes=" + bebes +
                                                                                    "&daterange=" + llegada + " - " + salida +
                                                                                    "&solorequest=0" +
                                                                                    "&tarifa=" + unatarifa.id
                                                                                    : "/" + preidioma + t("peticion") +
                                                                                    "?idpropiedad=" + propiedad.id +
                                                                                    "&adultos=" + adultos +
                                                                                    "&ninos=" + ninos +
                                                                                    "&bebes=" + bebes +
                                                                                    "&entrada=" + llegada.replaceAll("-", "/") +
                                                                                    "&salida=" + salida.replaceAll("-", "/") +
                                                                                    "&solorequest=1" +
                                                                                    "&tarifa=" + unatarifa.id
                                                                            }
                                                                            className="px-4 text-white btn btn-sm text-nowrap rounded-pill tarifa-reservar"
                                                                            style={{
                                                                                background: config.color_corporativo_web,
                                                                                border: "1px solid " + config.color_corporativo_web
                                                                            }}
                                                                        >
                                                                            {propiedad.by_request == 0
                                                                                ? t("Reservar")
                                                                                : t("Petición")
                                                                            }

                                                                            <i className="fa-solid fa-arrow-right ms-1"></i>
                                                                        </a>
                                                                    )}

                                                                </div>

                                                            </div>

                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                    </div>
                                ))
                            ) : (
                                <>
                                    <div className="centra">
                                        {t("No hay disponibilidad para su búsqueda. Le invitamos a modificar las fechas, el número de huéspedes o la duración de la estancia.")}
                                    </div>
                                    {bloqueEstanciaMinima}
                                    {bloqueOtras}
                                </>
                            )}
                            {propiedades.length > 0 && bloqueEstanciaMinima}
                            {propiedades.length > 0 && bloqueOtras}
                            {bloqueNoDisponibles}
                        </div>
                    </div>
                    {
                        habitacionesSeleccionadasArray?.length > 0 &&
                        (
                            <>
                                {/* Mòbil: amb 300 propietats a la llista, la
                                    caixa d'habitacions seleccionades queda
                                    literalment al final de tota la pàgina.
                                    Aquest botó (al header, mateix mecanisme
                                    del .bh-mobile-sheet ja usat pels
                                    cercadors) la fa accessible sempre, sense
                                    haver de baixar. */}
                                <button
                                    type="button"
                                    className={"bh-cart-mobile-trigger" + (pulsarTrigger ? " bh-cart-mobile-trigger--pulsa" : "")}
                                    onClick={() => setCarritoAbierto(true)}
                                >
                                    <i className="fa-solid fa-bag-shopping"></i>
                                    {t("Ver mi reserva")}
                                    <span className="bh-cart-mobile-trigger__badge">{habitacionesSeleccionadasArray.length}</span>
                                </button>

                                {carritoAbierto && <div className="bh-mobile-backdrop" onClick={() => setCarritoAbierto(false)}></div>}

                                <div className="listaseleccion">
                                    <div className={"habitacionesseleccionadas bh-mobile-sheet" + (carritoAbierto ? " bh-mobile-sheet--open" : "")}>
                                        <div className="bh-mobile-sheet__header">
                                            <span>{t("Mi reserva")}</span>
                                            <button type="button" className="bh-mobile-sheet__close" onClick={() => setCarritoAbierto(false)} aria-label={t("Cerrar")}>
                                                <i className="fa-solid fa-xmark"></i>
                                            </button>
                                        </div>
                                        <div className="bh-cart">
                                        {
                                            habitacionesSeleccionadasArray.map((habitacion, indexLinia) => {
                                                const assignades = habitacionsPerLinia[indexLinia] || [];
                                                const key = `${habitacion.idpropiedad}-${habitacion.tarifa}`;
                                                const propiedadRef = todasLasPropiedades.find(p => p.id === habitacion.idpropiedad);
                                                const tarifaRef = propiedadRef?.tarifas?.find(t => t.id === habitacion.tarifa);
                                                const politica = tarifaRef?.info_tarifa?.politica;
                                                const precioTotal = (habitacion.precio * habitacion.cantidad) / 100;

                                                return (
                                                    <div className="bh-cart__item" key={key}>
                                                        <button
                                                            type="button"
                                                            className="bh-cart__eliminar"
                                                            onClick={() => eliminarHabitacion(habitacion.idpropiedad, habitacion.tarifa)}
                                                            aria-label={t("Eliminar")}
                                                        >
                                                            <i className="fa-solid fa-trash"></i>
                                                        </button>

                                                        <div className="bh-cart__top">
                                                            <div className="bh-cart__foto">
                                                                {propiedadRef?.foto_principal?.length ? (
                                                                    <LazyLoadImage
                                                                        effect='blur'
                                                                        threshold={10}
                                                                        src={ruta + "/propiedades/" + propiedadRef.id + "/fotos/web/thumb/" + propiedadRef.foto_principal[0].nombre}
                                                                        alt={habitacion.nombrepropiedad}
                                                                    />
                                                                ) : (
                                                                    <img src="/images/web/bedloop-nofoto.png" alt="" />
                                                                )}
                                                            </div>

                                                            <div className="bh-cart__preu">
                                                                <strong>{precioTotal.toFixed(2)} {moneda}</strong>
                                                            </div>
                                                        </div>

                                                        {/* Nom a sota de la imatge (i no al seu costat): amb
                                                            noms de propietat llargs no hi cabia en una fila
                                                            compartida amb la foto i el preu. */}
                                                        <div className="bh-cart__info">
                                                            <h4>
                                                                {habitacion.nombrepropiedad}
                                                                {Number(habitacion.cantidad) > 1 && (
                                                                    <span className="bh-cart__cantidad">x{habitacion.cantidad}</span>
                                                                )}
                                                            </h4>
                                                            {(habitacion.nombretarifa || politica?.nombre?.[lang]) && (
                                                                <p className="bh-cart__subtitulo">
                                                                    {habitacion.nombretarifa}
                                                                    {politica?.nombre?.[lang] && (
                                                                        <>
                                                                            {" ("}
                                                                            <button
                                                                                type="button"
                                                                                className="bh-cart__politica"
                                                                                onClick={() => setModalPolitica({ nombre: politica.nombre?.[lang], descripcion: politica.descripcion?.[lang] })}
                                                                            >
                                                                                {politica.nombre[lang]}
                                                                            </button>
                                                                            {")"}
                                                                        </>
                                                                    )}
                                                                </p>
                                                            )}

                                                            {llegada && salida && (
                                                                <span className="bh-cart__badge">
                                                                    <i className="fa-regular fa-calendar"></i>
                                                                    {formatoFechaLlarga(llegada)} - {formatoFechaLlarga(salida)}
                                                                </span>
                                                            )}

                                                            <div className="bh-cart__meta">
                                                                {nochesSeleccion !== null && (
                                                                    <span><i className="fa-regular fa-moon"></i> {nochesSeleccion} {t("Noches")}</span>
                                                                )}
                                                                {assignades.length === 0 && adultos > 0 && (
                                                                    <span><i className="fa-regular fa-user"></i> {adultsPerLinia[indexLinia]} {t("Adultos")}</span>
                                                                )}
                                                            </div>
                                                            {assignades.map((hab) => (
                                                                <div className="bh-cart__hab" key={hab.numero}>
                                                                    <strong>{t("Habitación")} {hab.numero}</strong>
                                                                    <span>
                                                                        <i className="fa-regular fa-user"></i> {hab.adultos} {hab.adultos == 1 ? t("Adulto") : t("Adultos")}
                                                                        {hab.ninos > 0 && <>, {hab.ninos} {hab.ninos == 1 ? t("Niño") : t("Niños")}</>}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        <div className="bh-cart__bottom">
                                                            <button
                                                                type="button"
                                                                className={"bh-cart__details" + (detallesAbiertos[key] ? " bh-cart__details--obert" : "")}
                                                                onClick={() => toggleDetalles(key)}
                                                            >
                                                                {t("Detalles")} <i className="fa-solid fa-chevron-down"></i>
                                                            </button>

                                                            {detallesAbiertos[key] && (
                                                                <div className="bh-cart__grid">
                                                                    <div className="bh-cart__grid-item">
                                                                        <span>{t("Tarifa")}</span>
                                                                        <strong>{habitacion.nombretarifa || "—"}</strong>
                                                                    </div>
                                                                    <div className="bh-cart__grid-item">
                                                                        <span>{t("Cancelación")}</span>
                                                                        {politica?.nombre?.[lang] ? (
                                                                            <strong>
                                                                                <button
                                                                                    type="button"
                                                                                    className="bh-cart__politica"
                                                                                    onClick={() => setModalPolitica({ nombre: politica.nombre?.[lang], descripcion: politica.descripcion?.[lang] })}
                                                                                >
                                                                                    {politica.nombre[lang]}
                                                                                </button>
                                                                            </strong>
                                                                        ) : (
                                                                            <strong>—</strong>
                                                                        )}
                                                                    </div>
                                                                    <div className="bh-cart__grid-item">
                                                                        <span>{t("Habitaciones")}</span>
                                                                        <strong>{propiedadRef?.num_habitaciones ?? "—"}</strong>
                                                                    </div>
                                                                    <div className="bh-cart__grid-item">
                                                                        <span>{t("Huéspedes")}</span>
                                                                        <strong>
                                                                            {assignades.length > 0
                                                                                ? assignades.map(h => h.adultos).reduce((a, b) => a + b, 0)
                                                                                : adultsPerLinia[indexLinia]} {t("Adultos")}
                                                                        </strong>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>

                                    <div className="bh-cart__resum">
                                        <div className="bh-cart__resum-total">
                                            <span>{t("Total")}</span>
                                            <strong>{(totalSeleccionado / 100).toFixed(2)} {moneda}</strong>
                                        </div>
                                        {conflicteCarret && (
                                            <div className="mt-2 small text-danger">
                                                {t("Tu selección incluye propiedades del mismo grupo que no se pueden reservar juntas. Elimina una para continuar.")}
                                            </div>
                                        )}
                                        <button
                                            type="button"
                                            className="mt-2 btn btn-primary btn-icon" style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web }}
                                            onClick={prepararReserva}
                                            disabled={conflicteCarret}
                                        >
                                            {t("Continuar reserva")}
                                        </button>
                                    </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
            </div >
        </>
    );
};

export default PropiedadesBuscar;
